export default {
  startingPitchers: {
    title: "Lanzadores abridores",
    tabs: {
      byPitcher: "Por lanzador",
      allPitchers: "Todos los lanzadores",
    },
    labels: {
      confirmed: "CONFIRMADO",
      expected: "PREVISTO",
      pitcher: "LANZADOR",
      tbd: "POR DEFINIR",
    },
    empty: {
      title: "No hay lanzadores abridores disponibles",
    },
  },
};